import {
  Group,
  NumberFormatter,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { IconBuildingCommunity, IconUsers } from "@tabler/icons-react";
import { useMemo } from "react";
import { IconEmail } from "../../../../../assets/icons/IconEmail";
import { IconLinkedin } from "../../../../../components/Icons/IconLinkedin";

const ListNumbers = ({ currentList, serverInfo }) => {
  const list = useMemo(() => {
    return [
      {
        label: "Contacts",
        value: "number_of_contacts",
        icon: (
          <ThemeIcon variant="light" color="primary" size={"md"}>
            <IconUsers size={18} />
          </ThemeIcon>
        ),
      },
      {
        label: "Emails",
        value: "number_of_emails",
        icon: (
          <ThemeIcon variant="light" color="orange.4" size={"md"}>
            <IconEmail size={18} />
          </ThemeIcon>
        ),
      },
      {
        label: "LinkedIn URL",
        value: "number_of_linkedin_url",
        icon: (
          <ThemeIcon variant="light" color="blue.4" size={"md"}>
            <IconLinkedin size={18} />
          </ThemeIcon>
        ),
      },
    ];
  }, []);  

  return (
    <Group gap={"xl"}>
      {list.map((item) => (
        <Group gap={6} key={item.value}>
          <Tooltip label={item.label}>{item.icon}</Tooltip>

          <Text size="sm" fw={500}>
            {serverInfo?.[item.value] ? (
              <NumberFormatter value={serverInfo[item.value]} />
            ) : (
              "-"
            )}
            {serverInfo?.[item.value] < currentList?.[item.value] &&
            serverInfo?.[item.value] ? (
              <b style={{ marginLeft: 10 }}>
                ( <NumberFormatter value={currentList?.[item.value]} /> )
              </b>
            ) : (
              ""
            )}
          </Text>
        </Group>
      ))}

      <Group gap={6}>
        <Tooltip label={"Company"}>
          <ThemeIcon variant="light" color="violet.4" size={"md"}>
            <IconBuildingCommunity size={18} />
          </ThemeIcon>
        </Tooltip>

        <NumberFormatter
          thousandSeparator=" "
          value={currentList?.["number_of_companies"]}
        />
      </Group>
    </Group>
  );
};

export default ListNumbers;
